const TITLE_WIDTHS = ['88%', '72%', '94%', '68%', '81%', '76%', '90%', '64%'];

type McpChatHistorySidebarPreloadProps = {
  rows?: number;
};

/** Skeleton rows matching `.mcp-history-item` in the chat sidebar. */
export function McpChatHistorySidebarPreload({
  rows = 8
}: McpChatHistorySidebarPreloadProps) {
  return (
    <div className="placeholder-glow" aria-hidden>
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className="mcp-history-item">
          <span
            className="placeholder rounded flex-shrink-0"
            style={{ width: 15, height: 15 }}
          />
          <span
            className="placeholder rounded"
            style={{
              width: TITLE_WIDTHS[index % TITLE_WIDTHS.length],
              height: 12,
              maxWidth: '100%'
            }}
          />
        </div>
      ))}
    </div>
  );
}
